import type { PriceRuleFormValue } from '../hooks/usePriceModifierFields'

/**
 * Same rule as legacy price template modal / listing plan: template grid when the
 * platform exposes `/platform-price-field` rows; legacy repricing only when catalog is empty.
 */
export const shouldUseListingProfileTemplatePriceUi = (
  catalogFieldCount: number,
  catalogLoading: boolean
): boolean => !catalogLoading && catalogFieldCount > 0

/**
 * After hydrate or on edit open: keep mapped rows when present; otherwise seed
 * default NO_CHANGE rows from the platform catalog (create parity).
 */
export const resolvePriceRulesAfterTemplateHydrate = <T extends PriceRuleFormValue>(
  mappedRules: T[],
  catalogFieldCount: number,
  buildDefaultRules: () => T[]
): T[] => {
  if (mappedRules.length > 0) return mappedRules
  if (catalogFieldCount > 0) return buildDefaultRules()
  return []
}

/** Functional updater: seed defaults only when state is still empty and user has not edited. */
export const seedTemplatePriceRulesIfEmpty = <T extends PriceRuleFormValue>(
  currentRules: T[],
  catalogFieldCount: number,
  userTouchedRules: boolean,
  buildDefaultRules: () => T[]
): T[] => {
  if (userTouchedRules || currentRules.length > 0 || catalogFieldCount === 0) {
    return currentRules
  }
  return buildDefaultRules()
}
